import React, {Component, PropTypes} from 'react';
import { RequiredLegend } from '../../../common';
import styleable from 'react-styleable';
import defaultStyle from './radio-element.style.js';

export class RadioElement extends Component {
  isChecked(value) {
    const { response, defaultValue } = this.props;

    if(response !== undefined)
      return !!response && response.indexOf(value) !== -1;
    else
      return !!defaultValue && defaultValue.indexOf(value) !== -1;
  }

  render() {
    const { isRequired, label, options, id, onChange, disabled, errors, showErrors, css } = this.props;
    const hasErrors = errors && errors.length > 0;
    const errorIds = errors && errors.map(error => error.id + ' ');

    return (
      <fieldset
        id={id}
        role="radiogroup"
        className={css.fieldset}
        aria-required={isRequired}
        aria-invalid={hasErrors && showErrors}
        aria-describedby={errorIds}>
        <RequiredLegend hasErrors={hasErrors && showErrors} content={label} isRequired={isRequired}/>
        {options.map(option => (
          <div key={`${id}-${option.value}`}>
            <label className={css.buttonLabel} htmlFor={option.id}>
              <input
                name={'group' + id}
                id={option.id}
                className={css.radioButton}
                value={option.value}
                type="radio"
                disabled={disabled}
                onChange={e => onChange(e.target.value, !this.isChecked(option.value))}
                checked={this.isChecked(option.value)} />
              {option.label}
            </label>
            <br/>
          </div>
        ))}
      </fieldset>
    );
  }
}

RadioElement.propTypes = {
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  id: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  response: PropTypes.array,
  defaultValue: PropTypes.array,
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  showErrors: PropTypes.bool
};

export default styleable(defaultStyle) (RadioElement);



// WEBPACK FOOTER //
// src/common/form-elements/radio-element-folder/radio-element.js